import { V2Skeleton as Skeleton } from "@stacklet/ui";

interface Props {
  topMargin?: number;
  size?: "small" | "medium" | "large";
  hasFilterBar?: boolean;
}

export function TableSkeleton({
  topMargin,
  size = "medium",
  hasFilterBar = true,
}: Props) {
  let height = "";

  switch (size) {
    case "small":
      height = "200px";
      break;

    case "medium":
      height = "500px";
      break;

    case "large":
      height = "1000px";
      break;
  }

  return (
    <div
      className="flex h-4/5 w-full flex-col justify-between"
      style={{ marginTop: `${(topMargin ?? 1) * 8}px` }}
    >
      {hasFilterBar ? (
        <Skeleton height="45px" variant="rectangular" width="100%" />
      ) : null}
      <Skeleton
        className="mt-2"
        height={height}
        variant="rectangular"
        width="100%"
      />
      <div className="flex h-[30px] w-full justify-end">
        <Skeleton
          className="mt-2"
          height="28px"
          variant="rectangular"
          width="144px"
        />
      </div>
    </div>
  );
}
